import { FC, MouseEventHandler, ReactNode } from "react";
import styles from "./index.module.scss";
import TopBar from "./TopBar";
import classNames from "classnames";
import SnowAnimation from "../animations/SnowAnimation";
import { getBoolean } from "firebase/remote-config";
import { remoteConfig } from "@/services/firebase";

interface LayoutProps {
  children: ReactNode;
  childrenClassName?: string;
  onClick?: MouseEventHandler<HTMLDivElement> | undefined;
  hideTopBar?: boolean;
  hasAnimation?: boolean;
  isScrollable?: boolean;
}

const Layout: FC<LayoutProps> = ({
  children,
  childrenClassName,
  onClick,
  hideTopBar,
  hasAnimation,
  isScrollable,
  ...rest
}) => {
  const isSnowing = getBoolean(remoteConfig, "is_snowing");

  return (
    <div className={classNames(styles.container)} onClick={onClick} {...rest}>
      {!hideTopBar && <TopBar />}
      <div
        className={classNames(
          styles.contentBox,
          isScrollable && styles.scrollableContentBox,
          childrenClassName
        )}>
        {children}
      </div>
      {isSnowing && <SnowAnimation hasAnimation={hasAnimation} />}
    </div>
  );
};

export default Layout;
